import { migrationTable } from '../../../../../registry/migration_table';
import { ChainedSchema } from '../../general/ChainedSchema';
class SerializrType_ensureValidTraitRegistryKey extends ChainedSchema {
    registryType;
    constructor(propSchema, registryType) {
        super(propSchema);
        this.registryType = registryType;
    }
    deserializer(context) {
        const value = context.json;
        if (migrationTable[this.registryType][value]) {
            context.json_overwrite = migrationTable[this.registryType][value];
            console.log(`migrate registry key from ${value} to ${context.json_overwrite}`);
        }
        return this.parentSchema.deserializer(context);
    }
}
export function ensureValidTraitRegistryKey(registryType, propSchema) {
    return new SerializrType_ensureValidTraitRegistryKey(propSchema, registryType);
}
